/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { makeStyles, tokens, typographyStyles } from "@microsoft/shifts-ui-core";

export const useStyles = makeStyles({
    slotDropdown: {
        minWidth: "100px",
        width: "100px",
        "& .fui-Combobox": {
            width: "100%"
        },
        "& input": {
            width: "100%",
            minWidth: "0"
        },
        "& button": {
            minWidth: "24px",
            width: "24px",
            padding: "0"
        }
    },
    shiftThemeContainer: {
        boxShadow: "none",
        height: "32px !important",
        paddingLeft: "4px",
        width: "140px"
    },
    shiftBlockContainer: {
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        borderRadius: tokens.borderRadiusMedium,
        padding: tokens.spacingVerticalM,
        marginTop: tokens.spacingVerticalM,
        marginBottom: tokens.spacingVerticalM,
        gap: tokens.spacingVerticalS
    },
    iconButtonsContainer: {
        display: "flex",
        justifySelf: "end",
        marginLeft: "auto",
        gap: tokens.spacingHorizontalS
    },
    shiftBlockContent: {
        display: "flex",
        flexDirection: "row",
        justifyItems: "start",
        alignItems: "center",
        width: "522px",
        gap: tokens.spacingHorizontalM
    },
    shiftsBlockLabel: {
        ...typographyStyles.caption1,
        color: tokens.colorNeutralForeground3
    },
    repeatOnContainer: {
        display: "flex",
        flexDirection: "row",
        gap: tokens.spacingHorizontalS,
        width: "100%",
        justifyContent: "space-between",
        paddingLeft: tokens.spacingHorizontalXXS,
        paddingRight: tokens.spacingHorizontalXXS
    },
    dayOfTheWeek: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "70px",
        height: "32px",
        borderRadius: tokens.borderRadiusMedium,
        fontSize: tokens.fontSizeBase200,
        fontWeight: tokens.fontWeightMedium,
        textTransform: "uppercase",
        cursor: "pointer",
        transitionProperty: "background-color, color, border-color, box-shadow",
        transitionDuration: tokens.durationNormal,
        ...typographyStyles.caption2Strong,
        ":focus": {
            outline: "none",
            boxShadow: `0 0 0 1px ${tokens.colorStrokeFocus2}`
        },
        ":focus-visible": {
            outline: "none",
            boxShadow: `0 0 0 1px ${tokens.colorStrokeFocus2}`
        }
    },
    selected: {
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundOnBrand
    },
    unselected: {
        backgroundColor: tokens.colorNeutralBackground3,
        color: tokens.colorNeutralForeground2,
        border: `1px solid ${tokens.colorNeutralStroke3}`
    }
});
